import { ReactElement } from 'react';

import { PatientId } from '@dreryk/egabinet-patient-published-language-api';
import {
   VisitCreatePrescriptionOnlyOutOfScheduleCommand,
   VisitCreatePrescriptionOnlyOutOfScheduleCommandResult,
   VisitDocumentationScope,
} from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { ActionBar, ButtonVariant, PreventPrompt, useHistoryPushWithBackAction } from '@dreryk/react-components';
import { Choice } from '@dreryk/watermelon';

import { visitPaths } from '~libs.desktop.shared.paths';

import { patientTranslationKeys } from '../../translations';

type RepeatPrescriptionsLocationData = {
   readonly documentationScope: VisitDocumentationScope;
};

type RepeatSelectedPrescriptionsActionProps = {
   readonly patientId: number;
   readonly selectedPrescriptionIds: ReadonlySet<number>;
};

export const RepeatSelectedPrescriptionsAction = (props: RepeatSelectedPrescriptionsActionProps): ReactElement => {
   const push = useHistoryPushWithBackAction<RepeatPrescriptionsLocationData>(true);
   const selectedCount = props.selectedPrescriptionIds.size;

   const { executeAsync: repeatSelectedPrescriptions } = useCqrsCommand<
      VisitCreatePrescriptionOnlyOutOfScheduleCommandResult,
      void
   >(
      () => {
         const command = new VisitCreatePrescriptionOnlyOutOfScheduleCommand();
         command.patientId = PatientId.of(props.patientId);
         command.prescriptionToCopyIds = Choice.of([...props.selectedPrescriptionIds]);
         return command;
      },
      {
         onSuccess: (result) => {
            push(
               visitPaths.getVisitInterviewPath({
                  params: {
                     visitId: result.visitId.asNumber(),
                  },
               }),
               {
                  preventPrompt: PreventPrompt.ALWAYS,
                  data: {
                     documentationScope: 'PRESCRIPTION_ONLY',
                  },
               }
            );
         },
      }
   );

   return (
      <ActionBar.PrimaryButton
         testId={'repeatSelectedPrescriptions'}
         label={patientTranslationKeys.repeatSelectedPrescriptions}
         variant={ButtonVariant.PRIMARY}
         disabled={!selectedCount}
         onClick={async () => repeatSelectedPrescriptions()}
         blockingOperation
      />
   );
};
